window.n2m_i18n = function (key) {
    if (key in N2M_I18N) {
        return N2M_I18N[key];
    }

    return key;
};

require("./inc/trace.js");
// TODO: nos olvidamos por ahora del closable que hace cosas raras
// require("./inc/popoverClosable.js");

// TODO: dividir este js entre privado y publico?

require("./inc/modal-alert.js");
require("./inc/modal-ajax.js");
require("./inc/popovers.js");
require("./inc/one2one-request-form.js");
require("./inc/datepicker.js");
require("./inc/autocomplete.js");
require("./inc/file-upload.js");

// moz667: por culpa de vrdemo
var $ = jQuery;

$(document).ready(function () {
    var $body = $("body");

    datepicker_init();

    // Contenedor para insertar los toast de notificaciones
    $body.append('<div id="notification-msg-container" style="position: absolute; top: 50px; right: 50px; z-index: 99999;"></div>');

    // Activa la opcion de menu segun la plantilla que estemos usando
    $(".nav-item").removeClass("active");
    if ($body[0].classList.length && $body[0].classList.length > 0) {
        for (var i = 0; i < $body[0].classList.length; i++) {
            $(".nav-item.nav-" + $body[0].classList[i]).addClass("active");
        }
    }
    if ($(".nav-item.active").length == 0) {
        $(".nav-item.nav-home").addClass("active");
    }

    if ($body.hasClass("one2one-request-join")) {
        require("./inc/one2one-request-join.js");
    }

    // TODO: por ahora usamos el mismo... ya veremos si separamos
    if ($body.hasClass("stream-room-join") ) {
        require("./inc/stream/participant.js");
    } else if ($body.hasClass("stream-room-join-owner")) {
        require("./inc/stream/manager.js");
    }

    // trace_log("INIT!!!");

    // Cargar tabs de forma automatica
    var current_url = document.location.toString();

    if (current_url.match('#') && current_url.split('#').length > 1) {
        var $tab = $('.nav-tabs a[href="#' + current_url.split('#')[1] + '"]');
        if ($tab.length > 0) {
            $tab.tab('show');
        }
    }

    // Cargar hash del target de las tabs
    $('.nav-tabs a').on('shown.bs.tab', function (e) {
        // Para evitar el scroll, tenemos que quitarle el id a la tab antes de
        // establecer el hash en location
        var hash = e.target.hash;
        hash = hash.replace( /^#/, '' );
        var $tab_content = $( '#' + hash );
        if ( $tab_content.length ) {
            $tab_content.attr( 'id', '' );
        }
        window.location.hash = hash;
        if ( $tab_content.length ) {
            $tab_content.attr( 'id', hash );
        }
    });

    // Activar popovers
    activate_popovers();

    // notificaciones
    if ($(".notification-link").length > 0 && N2M.NOTIFICATION_READ_URL) {
        require("./inc/notifications.js");
    }

    // autoenable buttons:
    require("./inc/auto-enabled.js");

    // one2one-request-form
    init_one2one_request_form();

    // modal ajax forms
    require("./inc/modal-ajax-forms.js");

    // modal ajax page contents
    $("a.modal-ajax-content").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            load_ajax_content($(this).attr("href") + " .page-content", $(this).data("title"), $(this).data("css-class"));
        });
    });

    // Cronometro
    if ($(".temporizador").length > 0) {
        var $temporizador = $(".temporizador");

        if ($temporizador.data("date") && $temporizador.data("date") > N2M.NOW) {
            $temporizador.TimeCircles({
                circle_bg_color: N2M.CSS_ALT1_BG_COLOR,
                time: {
                    Days: {
                        text: n2m_i18n("Días"),
                        color: N2M.CSS_ALT2_BG_COLOR
                    },
                    Hours: {
                        text: n2m_i18n("Horas"),
                        color: N2M.CSS_ALT2_BG_COLOR
                    },
                    Minutes: {
                        text: n2m_i18n("Minutos"),
                        color: N2M.CSS_ALT2_BG_COLOR
                    },
                    Seconds: {
                        text: n2m_i18n("Segundos"),
                        color: N2M.CSS_ALT2_BG_COLOR
                    }
                }
            });
        } else {
            $temporizador.hide();
        }
    }

    // InfiniteScroll
    $(".vermas_resultados").hide();

    if ($(".vermas_resultados .page-link").length > 0) {
        var elem = document.querySelector('.page-content');
        var infScroll = new InfiniteScroll( elem, {
            // options
            path: '.vermas_resultados .page-link',
            append: '.paginated-row',
            history: false,
        });
    }

    // Autocomplete fields
    autocomplete_init();

    // Upload fields
    file_upload_init();

    // Videos modales
    require("./inc/modal-videos.js");

    // Imagenes modales
    require("./inc/modal-images.js");

    if ($body.hasClass("streaming-detail")) {
        require("./inc/streaming-detail.js");
    }

    // question
    require("./inc/streaming-questions.js");
    // question Admin
    require("./inc/streaming-questions-manage.js");

    // audit:
    require("./inc/audit.js");

    // audit clicks extra:
    require("./inc/audit-click.js");


    // Script de la maqueta scripts.js
    require("./inc/base.js");

    // Widget de sponsors
    require("./inc/sponsors-widget.js");

    // Stands db
    require("./inc/stands.js");

    // Under construction
    $(".under-construction").each(function (e) {
        var $launcher = $(this);

        $launcher.off("click").on("click", function (ec) {
            ec.preventDefault();

            alertDialog.show({
                title: $launcher.attr("title") ? $launcher.attr("title") : n2m_i18n("En construcción"),
                message: $launcher.data("under-construction-message") ? $launcher.data("under-construction-message") : n2m_i18n("Esta sección se encuentra en construcción.")
            });
        });
    });

    // Change icon
    $('.section-title[data-toggle="collapse"]').on({
        'click': function() {
            var $this = $(this);

            if ($this.attr('aria-expanded') === 'true') {
                $this.find('img').attr('src', $this.data("icon-off"));
            } else {
                $this.find('img').attr('src', $this.data("icon-on"));
            }
        }
    })
});
